import PromoCard from "../PromoCard/index.tsx";

export default function POVTenseCard({ onClose }: { onClose: () => void }) {
  return (
    <PromoCard
      badge="New"
      title="Consistent POV & Tense"
      description="Tell Sudowrite once, then stop thinking about it."
      ctaLabel="Learn More"
      ctaUrl="https://feedback.sudowrite.com/changelog/introducing-pov-and-tense-settings"
      onClose={onClose}
    />
  );
}
